'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useContext, useRef, useState } from 'react';
import { ButtonElement, AccordionSectionText, AccordionSectionWrapper, AccordionSectionContent, RotatingIcon, AccordionDivider, Leader } from './elements';
import { Icon } from '../Icon';
import { useCurrentAccordionIndex } from './hooks/useCurrentAccordionIndex';
import AccordionContext from './AccordionContext';
import { Text } from '../Text';
import { StateLayer } from '../../core-components';
export const AccordionSection = /*#__PURE__*/React.forwardRef(({
  buttonClassName = '',
  iconWrapperClassName = '',
  ariaLabel = '',
  iconSrc,
  children,
  header,
  subheader,
  startOpen = false,
  transitionMaxHeight = '100vh',
  transitionDuration = '.4s',
  transitionTimingFunction = 'cubic-bezier(.68,.12,.24,.99)',
  onClick,
  onOpenStateChange,
  isOpen,
  ...rest
}, fRef) => {
  const {
    numbered,
    variant
  } = useContext(AccordionContext);
  const accordionRef = useRef(null);
  const accordionIndex = useCurrentAccordionIndex(accordionRef);
  const [accordionOpen, setAccordionOpenState] = useState(isOpen ?? startOpen);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const renderIcon = () => /*#__PURE__*/React.createElement(Leader, {
    className: iconWrapperClassName
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    fill: "currentColor",
    size: "large"
  }));
  const renderNumber = () => /*#__PURE__*/React.createElement(Leader, null, /*#__PURE__*/React.createElement(Text, {
    weight: "heavy",
    size: 2
  }, accordionIndex, "."));
  const initialRender = useRef(true);
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      setAccordionOpenState(isOpen);
      setShouldAnimate(true);
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(AccordionSectionWrapper, {
    $variant: variant,
    "data-aui": "accordion.section",
    ref: accordionRef
  }, /*#__PURE__*/React.createElement(ButtonElement, _extends({
    ref: fRef,
    className: buttonClassName,
    "aria-label": ariaLabel,
    "aria-expanded": accordionOpen,
    onClick: e => {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
      onOpenStateChange === null || onOpenStateChange === void 0 ? void 0 : onOpenStateChange(!accordionOpen);
      setAccordionOpenState(!accordionOpen);
      setShouldAnimate(true);
    }
  }, rest), /*#__PURE__*/React.createElement(StateLayer, null), numbered ? renderNumber() : iconSrc && renderIcon(), /*#__PURE__*/React.createElement(AccordionSectionText, null, /*#__PURE__*/React.createElement(Text, {
    weight: "heavy",
    size: 2
  }, header), subheader && /*#__PURE__*/React.createElement(Text, {
    size: 1,
    color: "var(--aui-on-surface-soft)"
  }, subheader)), /*#__PURE__*/React.createElement(RotatingIcon, {
    src: "chevron-down",
    size: "large",
    $rotateIcon: accordionOpen
  })), /*#__PURE__*/React.createElement(AccordionSectionContent, {
    "aria-hidden": !accordionOpen,
    $isOpen: accordionOpen,
    $shouldAnimate: shouldAnimate,
    $hasLeader: !!iconSrc || numbered,
    $transitionMaxHeight: transitionMaxHeight,
    $transitionDuration: transitionDuration,
    $transitionTimingFunction: transitionTimingFunction
  }, children), /*#__PURE__*/React.createElement(AccordionDivider, null));
});